export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAILURE = "PRODUCT_LIST_FAILURE";


export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAILURE = "PRODUCT_DETAILS_FAILURE";


export const PRODUCT_REVIEW_REQUEST = "PRODUCT_REVIEW_REQUEST";
export const PRODUCT_REVIEW_SUCCESS = "PRODUCT_REVIEW_SUCCESS";
export const PRODUCT_REVIEW_FAILURE = "PRODUCT_REVIEW_FAILURE";
export const PRODUCT_REVIEW_RESET = "PRODUCT_REVIEW_RESET";

//ADMIN
//ADD PRODUCT 
export const ADMIN_ADD_PRODUCT_REQUEST = "ADMIN_ADD_PRODUCT_REQUEST";
export const ADMIN_ADD_PRODUCT_SUCCESS = "ADMIN_ADD_PRODUCT_SUCCESS";
export const ADMIN_ADD_PRODUCT_FAILURE = "ADMIN_ADD_PRODUCT_FAILURE";
export const ADMIN_ADD_PRODUCT_RESET = "ADMIN_ADD_PRODUCT_RESET";

//ADMIN GET ALL PRODUCTS
export const ADMIN_PRODUCT_LIST_REQUEST = "ADMIN_PRODUCT_LIST_REQUEST";
export const ADMIN_PRODUCT_LIST_SUCCESS = "ADMIN_PRODUCT_LIST_SUCCESS";
export const ADMIN_PRODUCT_LIST_FAILURE = "ADMIN_PRODUCT_LIST_FAILURE";


//EDIT PRODUCT
export const ADMIN_EDIT_PRODUCT_REQUEST = "ADMIN_EDIT_PRODUCT_REQUEST";
export const ADMIN_EDIT_PRODUCT_SUCCESS = "ADMIN_EDIT_PRODUCT_SUCCESS";
export const ADMIN_EDIT_PRODUCT_FAILURE = "ADMIN_EDIT_PRODUCT_FAILURE";

//UPDATE PRODUCT
export const ADMIN_UPDATE_PRODUCT_DETAILS_REQUEST = "ADMIN_UPDATE_PRODUCT_DETAILS_REQUEST";
export const ADMIN_UPDATE_PRODUCT_DETAILS_SUCCESS = "ADMIN_UPDATE_PRODUCT_DETAILS_SUCCESS";
export const ADMIN_UPDATE_PRODUCT_DETAILS_FAILURE = "ADMIN_UPDATE_PRODUCT_DETAILS_FAILURE";
export const ADMIN_UPDATE_PRODUCT_DETAILS_RESET = "ADMIN_UPDATE_PRODUCT_DETAILS_RESET";

//DELETE PRODUCT
export const ADMIN_DELETE_PRODUCT_REQUEST = "ADMIN_DELETE_PRODUCT_REQUEST";
export const ADMIN_DELETE_PRODUCT_SUCCESS = "ADMIN_DELETE_PRODUCT_SUCCESS";
export const ADMIN_DELETE_PRODUCT_FAILURE = "ADMIN_DELETE_PRODUCT_FAILURE";

//GET ALL REVIEWS
export const ADMIN_GET_REVIEWS_REQUEST = "ADMIN_GET_REVIEWS_REQUEST";
export const ADMIN_GET_REVIEWS_SUCCESS = "ADMIN_GET_REVIEWS_SUCCESS";
export const ADMIN_GET_REVIEWS_FAILURE = "ADMIN_GET_REVIEWS_FAILURE";

//MERCHANT
//ADD PRODUCT 
export const MERCHANT_ADD_PRODUCT_REQUEST = "MERCHANT_ADD_PRODUCT_REQUEST";
export const MERCHANT_ADD_PRODUCT_SUCCESS = "MERCHANT_ADD_PRODUCT_SUCCESS";
export const MERCHANT_ADD_PRODUCT_FAILURE = "MERCHANT_ADD_PRODUCT_FAILURE";
export const MERCHANT_ADD_PRODUCT_RESET = "MERCHANT_ADD_PRODUCT_RESET";

//MERCHANT GET ALL PRODUCTS
export const MERCHANT_PRODUCT_LIST_REQUEST = "MERCHANT_PRODUCT_LIST_REQUEST";
export const MERCHANT_PRODUCT_LIST_SUCCESS = "MERCHANT_PRODUCT_LIST_SUCCESS";
export const MERCHANT_PRODUCT_LIST_FAILURE = "MERCHANT_PRODUCT_LIST_FAILURE"

//GET ALL REVIEWS: MERCHANTS
export const MERCHANT_GET_REVIEWS_REQUEST = "MERCHANT_GET_REVIEWS_REQUEST";
export const MERCHANT_GET_REVIEWS_SUCCESS = "MERCHANT_GET_REVIEWS_SUCCESS";
export const MERCHANT_GET_REVIEWS_FAILURE = "MERCHANT_GET_REVIEWS_FAILURE";

